<mat-nav-list>
  <a [routerLink]="menuService.cmdInfoHistory.route" mat-list-item (click)="openLink($event)">
    <span mat-line><mat-icon class="link-icon">{{menuService.cmdInfoHistory.icon}}</mat-icon>{{menuService.cmdInfoHistory.text}}</span>
  </a>

  <a [routerLink]="menuService.cmdInfoChanged.route" mat-list-item (click)="openLink($event)">
    <span mat-line><mat-icon class="link-icon">{{menuService.cmdInfoChanged.icon}}</mat-icon>{{menuService.cmdInfoChanged.text}}</span>
  </a>

  <a [routerLink]="menuService.cmdInfoWebDoku.route" mat-list-item (click)="openLink($event)">
    <span mat-line><mat-icon class="link-icon">{{menuService.cmdInfoWebDoku.icon}}</mat-icon>{{menuService.cmdInfoWebDoku.text}}</span>
  </a>
</mat-nav-list>
